import { observer } from 'mobx-react';
import React from 'react';
import { Tracker } from '@udemy/event-tracking';
import { CategoryNavItemSelectEvent } from '../../../events';
import { useMobileNavStore } from '../../../hooks/use-mobile-nav-store';
import { MobileNavItem, MobileNavL1Nav, MobileNavSection } from '../mobile-nav.react-component';
export const MobileCategoryNav = observer(() => {
  var _mobileNavStore$navig;
  const mobileNavStore = useMobileNavStore();
  function handleCategoryNavClick(item) {
    const context = {
      categoryId: item.id,
      subcategoryId: null,
      topicId: null,
      uiRegion: 'mobile_nav'
    };
    Tracker.publishEvent(new CategoryNavItemSelectEvent({
      context
    }));
  }
  return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: "header-toggle-side-nav-categories"
  }, /*#__PURE__*/React.createElement(MobileNavSection, null, (_mobileNavStore$navig = mobileNavStore.navigationCategories) === null || _mobileNavStore$navig === void 0 ? void 0 : _mobileNavStore$navig.map(c => /*#__PURE__*/React.createElement(MobileNavItem, {
    onClick: () => handleCategoryNavClick(c),
    key: `mobile-nav-item-${c.id}`,
    cssToggleId: `header-toggle-side-nav-subcategories-of-${c.id}`,
    "data-purpose": "category-item"
  }, c.title))));
});
//# sourceMappingURL=mobile-category-nav.react-component.js.map